import React from 'react'
import './Header.css'

export const Header = () => {
  return (
    <div id="container1">
      <div id="items">
        <div id="logo">
          <img src='logo.png'></img>
          <h2><a href="#">SaveIT</a></h2>
        </div>
          <ul id="nav">
            <li><a href="#home">Home</a></li>
            <li><a href="#how-to-use">How to use?</a></li>
            <li><a href="#about-saveit">About SaveIT</a></li>
            <li><a href="#contact-me">Contact Me</a></li>
          </ul>
      </div>
    </div>
  )
}
